import { Fragment, type FC, type PropsWithChildren } from 'react';

import { useWineryTagManager } from '@xing-com/crate-companies-shared';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { HeaderLoggedOut } from '@xing-com/platform-layout-header-logged-out';
import { LoggedoutView } from '@xing-com/platform-layout-logged-out';
import { LayoutMain } from '@xing-com/platform-layout-main';

import { ErrorBoundary } from './components/error-boundary';
import { LoggedInPage } from './components/logged-in-page/logged-in-page';
import { LoggedOutPage } from './components/logged-out-page/logged-out-page';
import { CompaniesDataProvider } from './contexts/companies-data-context';
import { useCompaniesExperiments } from './hooks/use-companies-experiments/use-companies-experiments';
import { Router } from './routes/router';

const ErrorContainer: FC<PropsWithChildren> = ({ children }) => children;

const CustomLoggedOutLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <>
      <HeaderLoggedOut />
      <>{children}</>
    </>
  );
};

export const App: FC = () => {
  const { isLoggedIn } = useLoginState();
  useWineryTagManager();

  const { isNewLoggedOutExperimentEnabled } = useCompaniesExperiments();

  const LoggedOutGrid = isNewLoggedOutExperimentEnabled
    ? Fragment
    : LoggedOutPage;

  const AppComponent = isLoggedIn ? LoggedInPage : LoggedOutGrid;

  const LoggedOutLayout = isNewLoggedOutExperimentEnabled
    ? CustomLoggedOutLayout
    : LoggedoutView;
  const AppLayout = isLoggedIn ? LayoutMain : LoggedOutLayout;

  return (
    <>
      <AppLayout gridless testId="crate-layout-main" withSubNav>
        <ErrorBoundary>
          <ErrorContainer>
            <CompaniesDataProvider>
              <AppComponent>
                <Router />
              </AppComponent>
            </CompaniesDataProvider>
          </ErrorContainer>
        </ErrorBoundary>
      </AppLayout>
    </>
  );
};
